import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons';

export const AngleUpIcon = () => (
    <div className="angle-updown-icon">
        <FontAwesomeIcon icon={faAngleUp} />
    </div>
)
export default AngleUpIcon;




// WEBPACK FOOTER //
// ./src/components/icons/AngleUpIcon.js